<div class="flex justify-center pt-24 px-4">
  <div class="w-full max-w-md bg-white border border-gray-200 rounded-lg shadow-card px-8 py-8 text-center">
    <ng-container *ngIf="(message | async) as msg; else processing">
      <div class="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-success-100">
        <svg class="h-6 w-6 text-success-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <p class="text-base font-medium text-gray-900 m-0">{{ msg }}</p>
      <a class="button-primary w-full mt-6" href="/">Return to L&amp;R Midland</a>
    </ng-container>
    <ng-template #processing>
      <p class="loading-note justify-center m-0">Signing you out&hellip;</p>
    </ng-template>
  </div>
</div>
